<script setup>
import { ref } from 'vue';
import { useResizeObserver } from '@vueuse/core';

const contentElement = ref(null);
const expanded = ref(false);
const overflowing = ref(false);

useResizeObserver(contentElement, ([entry]) => {
  overflowing.value = entry.contentRect.height > 128;
});
</script>

<template>
  <div>
    <div :class="{ 'max-h-32 overflow-hidden': overflowing && !expanded }">
      <div ref="contentElement" class="flow-root">
        <slot />
      </div>
    </div>
    <button
      v-if="overflowing"
      type="button"
      class="expandable-content-toggle skip-context-menu ml-auto mt-2 block rounded text-sm font-semibold text-current underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-current"
      :aria-expanded="expanded"
      @click.stop="expanded = !expanded"
    >
      {{
        expanded
          ? $t('CONVERSATION.MESSAGE_SHOW_LESS')
          : $t('CONVERSATION.MESSAGE_SHOW_MORE')
      }}
    </button>
  </div>
</template>
